import { vRoster } from './view.js';
import { actions } from './actions.js';

export default { id: 'roster', label: 'Roster', icon: 'cal', nav: true, show: () => true, view: vRoster, actions };
